"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopBarGraph = DesktopBarGraph;
exports.MobileBarGraph = MobileBarGraph;
var _react = _interopRequireDefault(require("react"));
var _CalculateDesktopBarCharts = require("./CalculateDesktopBarCharts");
var _CalculateMobileBarCharts = require("./CalculateMobileBarCharts");
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function DesktopBarGraph(_ref) {
  var {
    willNeedValue,
    willHaveValue,
    retireIncomeGapValue
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-desktop-tablet-only"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-col"
  }, /*#__PURE__*/_react.default.createElement(_CalculateDesktopBarCharts.CalculateWillHaveDesktop, {
    willHaveValue: willHaveValue,
    willNeedValue: willNeedValue,
    retireIncomeGapValue: retireIncomeGapValue
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "barchart-bar-footer"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "You will have"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-bar basic-bar-setup need-gap-bar-color vertical-height100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-text"
  }, (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, willNeedValue)), ' ', "/mo")), /*#__PURE__*/_react.default.createElement("div", {
    className: "barchart-bar-footer"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "You will need"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-barchart-col"
  }, /*#__PURE__*/_react.default.createElement(_CalculateDesktopBarCharts.CalculateRetireIncomeGapDesktop, {
    willNeedValue: willNeedValue,
    retireIncomeGapValue: retireIncomeGapValue,
    willHaveValue: willHaveValue
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "barchart-bar-footer"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Your gap"))))))));
}
function MobileBarGraph(_ref2) {
  var {
    willNeedValue,
    willHaveValue,
    retireIncomeGapValue
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-mobile-only"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-bar-chart-container"
  }, /*#__PURE__*/_react.default.createElement(_CalculateMobileBarCharts.CalculateWillHaveMobile, {
    willHaveValue: willHaveValue,
    willNeedValue: willNeedValue
  })), /*#__PURE__*/_react.default.createElement("h4", null, "You will have", ' ', (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, willHaveValue)), " /mo"), /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-bar-chart-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-bar-fill-container-height need-gap-bar-color mobile-bar-100percent"
  })), /*#__PURE__*/_react.default.createElement("h4", null, "You will need", ' ', (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, willNeedValue)), " /mo"), /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-bar-chart-container"
  }, /*#__PURE__*/_react.default.createElement(_CalculateMobileBarCharts.CalculateRetirementIncomeGapMobile, {
    willNeedValue: willNeedValue,
    retireIncomeGapValue: retireIncomeGapValue,
    willHaveValue: willHaveValue
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Your gap", ' ', (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, retireIncomeGapValue) < 0 ? '0' : retireIncomeGapValue), ' ', "/mo")), /*#__PURE__*/_react.default.createElement("p", null));
}